/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

import {Component,Prop} from 'vue-property-decorator'
import AlarmSearchService from "./service/auditLogService";
import BasicSearchPage from "../../../components/basicSearchPage/basicSearchPage";
import override from "../../../dectorators/override";
import { DataAuditDOI } from './api/dataAuditApi';
import AuditLogService from './service/auditLogService';
import QueryForm from 'src/components/queryForm/queryForm';

@Component
export default class AuditLog extends BasicSearchPage<AlarmSearchService, DataAuditDOI.RowDataI, DataAuditDOI.QueryRowDataParamsI> {
    @Prop({
		type: String
	})
    mn!: string

    @Prop({
		type: String
	})
    name!: string
    
    checkBoxShow = false

    @override
    renderHead(h) {
        return <div></div>
    }
    @override
    renderQuery(h) {
		return <div style="width:100%">
            <div style="display: inline-block;line-height: 32px;font-size: 14px;vertical-align: middle;padding-bottom: 6px;width: 360px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">站点名称：{this.name}</div>
            <QueryForm style="display: inline-block;vertical-align: middle;" ref="queryForm" showClear={false} dataSource={this.queryFormData} on-search={this.search}/>
        </div>
	}
    
	@override
	loadService () {
        this.service = new AuditLogService(this)
    }
}
